import { useState, useEffect } from 'react';
import { Skeleton } from '../ui/skeleton';

export const PALETTE = ['#00b8d4', '#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

// Anima el llenado de las barras al terminar la carga
export const useBarsIn = (loading) => {
  const [barsIn, setBarsIn] = useState(false);
  useEffect(() => {
    if (!loading) {
      setBarsIn(false);
      const t = setTimeout(() => setBarsIn(true), 80);
      return () => clearTimeout(t);
    }
  }, [loading]);
  return barsIn;
};

export const SectionTitle = ({ title, subtitle, Icon }) => (
  <div className="mb-4 flex items-start gap-2">
    {Icon && <Icon className="h-4 w-4 text-muted-foreground flex-shrink-0 mt-0.5" strokeWidth={1.5} />}
    <div>
      <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide">{title}</h3>
      {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
  </div>
);

export const WidgetCard = ({ children, className = '', testid, delay = 0 }) => (
  <div
    data-testid={testid}
    className={`bg-card border border-border/60 rounded-xl p-5 shadow-sm dash-fade-up ${className}`}
    style={{ animationDelay: `${delay}ms` }}
  >
    {children}
  </div>
);

export const Legend = ({ items }) => (
  <div className="flex flex-wrap gap-x-4 gap-y-1.5 mt-4 justify-center">
    {items.map(d => (
      <div key={d.name} className="flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: d.color }} />
        <span className="text-xs text-muted-foreground">{d.name}</span>
      </div>
    ))}
  </div>
);

export const EmptyMsg = ({ text = 'Sin datos disponibles' }) => (
  <p className="text-sm text-muted-foreground py-8 text-center">{text}</p>
);

export const DashSkeleton = () => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
      {[0, 1, 2, 3].map(i => <Skeleton key={i} className="h-28 rounded-xl" />)}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
      <Skeleton className="h-72 rounded-xl lg:col-span-5" />
      <Skeleton className="h-72 rounded-xl lg:col-span-7" />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
      <Skeleton className="h-64 rounded-xl lg:col-span-5" />
      <Skeleton className="h-64 rounded-xl lg:col-span-7" />
    </div>
  </div>
);
